import React from 'react';
import DisposalDialog from './DisposalDialog';
import {DISPOSAL_METHOD_LABELS, DisposalIntent} from '../../support/itemLifecycle';
import {disposalMethodHint} from '../../support/disposalMethods';
import {formatDate} from '../../utils/dateTime';
import {pluralItems} from '../../utils/plural';

/** Сколько названий показываем целиком, прежде чем свернуть остаток в «и ещё N». */
const NAMES_SHOWN = 8;

/**
 * Подтверждение факта выбытия. Показывает ровно то, что произойдёт: какие вещи, каким
 * способом и какой датой покинут гардероб. Список — не украшение: по нему видно, не попала ли
 * в выборку лишняя вещь.
 *
 * <p>Формулировка стоит в момент действия и говорит правду (D12): решение было обратимо, пока
 * вещь оставалась у владельца; подтверждение закрывает карточку. Слова «отменить нельзя»
 * относятся именно к этому шагу, а не к решению, принятому стадией раньше.</p>
 */
export default function ConfirmDisposalDialog({method, names, date, onConfirm, onCancel}: {
    method: DisposalIntent;
    names: string[];
    date: string;
    onConfirm: () => void;
    onCancel: () => void;
}) {
    const shown = names.slice(0, NAMES_SHOWN);
    const rest = names.length - shown.length;
    return (
        <DisposalDialog
            title={`${DISPOSAL_METHOD_LABELS[method]}: ${pluralItems(names.length)}`}
            confirmLabel={DISPOSAL_METHOD_LABELS[method]}
            onConfirm={onConfirm}
            onCancel={onCancel}
        >
            <p>
                Способ: <b>{DISPOSAL_METHOD_LABELS[method].toLowerCase()}</b>
                {disposalMethodHint(method) && ` (${disposalMethodHint(method)})`}, дата:{' '}
                <b>{formatDate(date)}</b>.
            </p>
            <ul className="list-disc pl-5" data-testid="confirm-disposal-names">
                {shown.map(name => <li key={name}>{name}</li>)}
                {rest > 0 && <li>и ещё {rest}</li>}
            </ul>
            <p className="text-gray-500 dark:text-gray-400">
                Вы отмечаете то, что уже произошло. Вещи покидают гардероб и перестают участвовать
                в подборах, их карточки закрываются, история носки сохраняется. Отменить это
                подтверждение нельзя.
            </p>
        </DisposalDialog>
    );
}
